import { CSS as MenuCSS } from '../../components/menu/menu.style';

export const CSS = {
	container: 'c-AssignCollections',
	isLoading: 'c-AssignCollections--IsLoading',
	content: 'c-AssignCollections__Content',
	menu: 'c-AssignCollections__Menu',
};

export const Style = {
	[CSS.container]: {
		width: '600px',
	},
	[CSS.isLoading]: {
		display: 'flex',
		'justify-content': 'center',
	},
	[CSS.content]: {
		display: 'flex',
		'flex-direction': 'column',
		'align-items': 'start',
	},
	[CSS.menu]: {
		width: '600px',
		position: 'absolute',
		[`& .${MenuCSS.menu}`]: {
			right: 'auto',
			width: '100%',
		},
	},
};
